module.exports = __webpack_public_path__ + "static/media/Catalogue 1.15476b8f.jpg";